const offers = [
  {
    title: "品牌内容合作",
    desc: "以资讯内容为载体的原生合作，把品牌讲成值得被读到的好故事。",
    points: ["栏目冠名", "定制深度内容", "热点共创"],
    icon: "ri-quill-pen-line",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    title: "广告与流量投放",
    desc: "覆盖 3.8 万日均活跃的内容矩阵，为品牌提供可衡量的曝光与转化。",
    points: ["信息流投放", "开屏合作", "效果追踪"],
    icon: "ri-bar-chart-2-line",
    tone: "bg-accent-100 text-accent-700",
  },
  {
    title: "活动与跨界联名",
    desc: "从线上专题到线下快闪，一起做点让用户记住的联名事件。",
    points: ["专题共创", "线下活动", "联名周边"],
    icon: "ri-hand-heart-line",
    tone: "bg-secondary-100 text-secondary-800",
  },
];

const steps = [
  { n: "1", t: "留下意向", d: "说明品牌与合作目标" },
  { n: "2", t: "方案沟通", d: "商务团队 1 个工作日响应" },
  { n: "3", t: "确认执行", d: "明确排期与效果指标" },
];

export default function Business() {
  return (
    <section id="business" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 border-b border-foreground-200 pb-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] text-primary-600">
              BUSINESS
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              商务合作
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-right">
            吃瓜官网商务团队专注内容与品牌的双赢，欢迎品牌方、MCN
            与渠道伙伴来聊。
          </p>
        </div>

        {/* offers */}
        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {offers.map((o) => (
            <div
              key={o.title}
              className="group flex flex-col rounded-lg border border-background-200/80 bg-background-100/50 p-6 transition-colors hover:border-primary-200"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg ${o.tone}`}
              >
                <i className={`${o.icon} text-xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">
                {o.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{o.desc}</p>
              <ul className="mt-5 flex flex-wrap gap-2">
                {o.points.map((p) => (
                  <li
                    key={p}
                    className="whitespace-nowrap rounded-md bg-background-50 px-3 py-1.5 text-xs text-foreground-700"
                  >
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* process */}
        <div className="mt-12 rounded-lg border border-background-200/80 bg-background-100/60 p-6 md:p-8">
          <div className="flex items-center gap-3">
            <i className="ri-route-line text-2xl text-primary-600"></i>
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              合作流程，三步对齐
            </h3>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
            {steps.map((s) => (
              <div key={s.n} className="flex items-start gap-4">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-base font-bold text-background-50">
                  {s.n}
                </span>
                <div>
                  <p className="font-semibold text-foreground-900">{s.t}</p>
                  <p className="mt-1 text-sm text-foreground-600">{s.d}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-7 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-sm text-foreground-600">
              <i className="ri-mail-send-line mr-1.5 align-middle text-primary-600"></i>
              合作邮箱：business@chigua-official.com
            </p>
            <a
              href="#contact"
              className="whitespace-nowrap rounded-md bg-foreground-950 px-6 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              发起商务对接
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}